import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=4b0dccd6&lang=pug&"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports